"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Link = function Link(props) {
  return _react.default.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("title", null, props.altText), _react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: props.backgroundColor
  }), _react.default.createElement("path", {
    d: "M10 14.5C9.90111 14.5 9.80444 14.4707 9.72221 14.4157C9.63999 14.3608 9.5759 14.2827 9.53806 14.1913C9.50021 14.1 9.49031 13.9994 9.5096 13.9025C9.5289 13.8055 9.57652 13.7164 9.64644 13.6464L12.7929 10.5H6.5V17.5H13.5V11.2071L10.3536 14.3535C10.3072 14.4 10.2521 14.4369 10.1914 14.462C10.1307 14.4872 10.0657 14.5001 10 14.5Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M0 0V24H24V0H0ZM18.5 10C18.5 10.1326 18.4473 10.2598 18.3536 10.3536C18.2598 10.4473 18.1326 10.5 18 10.5C17.8674 10.5 17.7402 10.4473 17.6464 10.3536C17.5527 10.2598 17.5 10.1326 17.5 10V7.20711L14.5 10.2071V18C14.5 18.1326 14.4473 18.2598 14.3536 18.3536C14.2598 18.4473 14.1326 18.5 14 18.5H6C5.86739 18.5 5.74021 18.4473 5.64645 18.3536C5.55268 18.2598 5.5 18.1326 5.5 18V10C5.5 9.86739 5.55268 9.74021 5.64645 9.64645C5.74021 9.55268 5.86739 9.5 6 9.5H13.7929L16.7929 6.5H14C13.8674 6.5 13.7402 6.44732 13.6464 6.35355C13.5527 6.25979 13.5 6.13261 13.5 6C13.5 5.86739 13.5527 5.74021 13.6464 5.64645C13.7402 5.55268 13.8674 5.5 14 5.5H18C18.0045 5.5 18.0089 5.50056 18.0134 5.50067C18.0252 5.501 18.0371 5.50131 18.0489 5.50247C18.0579 5.50333 18.0667 5.50497 18.0755 5.50631C18.0828 5.50742 18.0901 5.50819 18.0973 5.50964C18.1067 5.5115 18.1158 5.51403 18.1251 5.51639C18.1317 5.51808 18.1383 5.5195 18.1449 5.52147C18.1537 5.52425 18.1623 5.52744 18.1709 5.53058C18.1777 5.53303 18.1845 5.53522 18.1911 5.53797C18.1992 5.54131 18.2069 5.54519 18.2148 5.54908C18.2217 5.55239 18.2286 5.55544 18.2355 5.55908C18.2431 5.56314 18.2503 5.56775 18.2577 5.57219C18.2643 5.57617 18.2711 5.57989 18.2775 5.58422C18.2859 5.58978 18.2936 5.59589 18.3016 5.60189C18.3066 5.60575 18.3119 5.60925 18.3169 5.61331C18.3425 5.63432 18.366 5.65782 18.387 5.68344C18.3911 5.68844 18.3946 5.69375 18.3985 5.69889C18.4045 5.70675 18.4106 5.7145 18.4161 5.72272C18.4205 5.72936 18.4244 5.73625 18.4284 5.74303C18.4324 5.74981 18.4372 5.75725 18.4412 5.76464C18.4451 5.77203 18.4481 5.77903 18.4516 5.78625C18.455 5.79347 18.4589 5.80122 18.4621 5.80897C18.465 5.81603 18.4674 5.82325 18.47 5.83042C18.4729 5.83875 18.4761 5.84675 18.4786 5.85514C18.4808 5.86233 18.4824 5.86964 18.4842 5.87689C18.4863 5.88542 18.4887 5.89386 18.4904 5.90256C18.4922 5.91125 18.4931 5.91947 18.4943 5.92794C18.4954 5.93558 18.4969 5.94314 18.4976 5.95089C18.4992 5.96647 18.4999 5.98214 18.5 5.99781C18.5 5.99858 18.5 5.99933 18.5 6.00014V10Z",
    fill: props.foregroundColor
  }));
};

Link.defaultProps = {
  altText: "Link",
  backgroundColor: "#FFFFFF",
  foregroundColor: "#2D5AB4"
};
Link.propTypes = {
  altText: _propTypes.default.string,
  backgroundColor: _propTypes.default.string,
  foregroundColor: _propTypes.default.string
};
var _default = Link;
exports.default = _default;